<template>
  <div>
    <div class="flex">
      <div class="flex-1 px-3 pb-3 overflow-hidden">
        <div class="flex items-center mb-6">
          <svg width="24" height="24"
            class="cursor-pointer"
            :class="{ 'opacity-25': !canGoPrevMonth }"
            @click="goToPrevMonth">
            <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
          </svg>
          <div class="flex-1 fs-14 text-center font-medium">
            <span class="-ml-6">
              {{ displayingMonth.format('MMMM YYYY') }}
            </span>
          </div>
        </div>

        <calendar-header :month="displayingMonth" />
        <calendar-grid
          :month="displayingMonth"
          :from="from"
          :to="to"
          @click="handleDateClicked" />
      </div>
      <div class="flex-none w-4"></div>
      <div class="flex-1 px-3 pb-3 overflow-hidden">
        <div class="flex items-center mb-6">
          <div class="flex-1 fs-14 fs-14 text-center font-medium">
            <span class="-mr-6">{{ nextDisplayingMonth.format('MMMM YYYY') }}</span>
          </div>
          <svg width="24" height="24" class="cursor-pointer" @click="goToNextMonth">
            <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
          </svg>
        </div>

        <calendar-header :month="nextDisplayingMonth" />
        <calendar-grid
          :month="nextDisplayingMonth"
          :from="from"
          :to="to"
          @click="handleDateClicked" />
      </div>
    </div>

    <footer>
      <hr class="datepicker-footer-separator" />
      <div class="float-right">
        <button type="button" class="datepicker-clear-btn btn btn-outlined btn-secondary mr-1"
          @click="handleClearDates">
          Clear Dates
        </button>
        <button type="button" class="btn btn-secondary"
          @click="handleSubmit">
          Continue
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import CalendarHeader from './CalendarHeader'
import CalendarGrid from './CalendarGrid'
import { determineBestDPRange } from '../../../helpers'

export default {
  components: {
    CalendarHeader,
    CalendarGrid
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      from: this.value[0],
      to: this.value[1],
      displayingMonth: this.value[0] ? this.value[0] : moment()
    }
  },
  computed: {
    canGoPrevMonth () {
      const thisMonth = moment().startOf('month')
      const displayingMonth = this.displayingMonth.clone().startOf('month')

      return displayingMonth.isAfter(thisMonth)
    },
    nextDisplayingMonth () {
      return this.displayingMonth.clone().add(1, 'months')
    }
  },
  methods: {
    goToPrevMonth () {
      if (this.canGoPrevMonth) {
        this.displayingMonth = this.displayingMonth.clone().add(-1, 'months')
      }
    },
    goToNextMonth () {
      this.displayingMonth = this.displayingMonth.clone().add(1, 'months')
    },
    handleDateClicked (date) {
      const [from, to] = determineBestDPRange(this.from, this.to, date)

      this.from = from
      this.to = to
      this.$emit('input', [from, to])
    },
    handleClearDates () {
      this.from = null
      this.to = null

      this.$emit('input', [null, null])
    },
    handleSubmit () {
      this.$emit('close')
    }
  }
}
</script>
